import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Stack, Text } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IHeadingProps = IContainerProps & {
  previousUrl?: string;
  icon?: React.ReactNode;
  title?: React.ReactNode;
  level?: 1 | 2 | 3;
  titleAction?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
};

const styles = stylex.create({
  host: {
    gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
    alignItems: 'center',
    color: colorSchemeTokens.onSurface,
  },
  icon: {
    fontSize: 24,
  },
  headline: {
    color: colorSchemeTokens.onSurfaceVariant,
  },
  subtitleText: {
    color: colorSchemeTokens.onSurfaceVariant,
  },
});

export const Heading: React.FC<IHeadingProps> = (props) => {
  const {
    sx,
    previousUrl,
    icon,
    title,
    level = 1,
    titleAction,
    subtitle,
    actions,
  } = props;
  const size = level === 1 ? 'lg' : level === 2 ? 'md' : 'sm';

  return (
    <div {...stylex.props(styles.host, sx)}>
      <Stack horizontal justify="space-between" align="start">
        <Stack gap={1}>
          <Stack horizontal gap={4}>
            {previousUrl ? (
              <IconButton
                icon={<FontAwesomeIcon icon={faArrowLeft} />}
                href={previousUrl}
              />
            ) : null}
            <Stack horizontal gap={3}>
              {icon ? <div {...stylex.props(styles.icon)}>{icon}</div> : null}
              <Text variant="headline" size={size} truncate>
                {title}
              </Text>
            </Stack>
            {titleAction}
          </Stack>

          {subtitle ? (
            <Text variant="body" size="lg" as="p" sx={styles.subtitleText}>
              {subtitle}
            </Text>
          ) : null}
        </Stack>
        <Stack horizontal gap={2}>
          {actions}
        </Stack>
      </Stack>
    </div>
  );
};
